import { forwardRef, type Ref, type SVGProps } from "react";
const IconRateHappyOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2m0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12"
    />
    <path
      fill="currentColor"
      d="M12 11a2 2 0 1 0 0 4 2 2 0 1 0 0-4m8 0a2 2 0 1 0 0 4 2 2 0 1 0 0-4m.29 8.29a6.24 6.24 0 0 1-8.58 0 1 1 0 0 0-1.42 1.42A8.5 8.5 0 0 0 16 23a8.5 8.5 0 0 0 5.71-2.29 1 1 0 0 0-1.42-1.42"
    />
  </svg>
);
const ForwardRef = forwardRef(IconRateHappyOutlineSVG);
ForwardRef.displayName = "IconRateHappyOutline";
export { ForwardRef as IconRateHappyOutline };
